"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Error_1 = require("../shared/Error");
class MessageRouterImp {
    constructor() {
        this.messageHandlers = new Map();
    }
    setHandler(messageType, messageHandler) {
        this.messageHandlers.set(messageType, messageHandler);
    }
    removeHandler(messageType) {
        this.messageHandlers.delete(messageType);
    }
    handleMessage(message) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const payload = JSON.parse(message.data.toString());
            if (this.isMessage(payload)) {
                (_a = this.messageHandlers.get(payload.messageName)) === null || _a === void 0 ? void 0 : _a.handle(payload);
            }
            else {
                return Promise.reject(Error_1.CustomerAuthnError.MALFORMED_MESSAGE);
            }
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isMessage(object) {
        return "messageName" in object && "payload" in object;
    }
}
exports.default = MessageRouterImp;
//# sourceMappingURL=MessageRouterImp.js.map